import React from 'react';

interface ModalHeaderSectionProps {
  highlight?: string;
  title: string;
  subtitle?: string;
}

const ModalHeaderSection = ({ highlight, title, subtitle }: ModalHeaderSectionProps) => {
  return (
    <div className="flex w-full items-center justify-center bg-grayscale-charcoal md:max-w-[600px] lg:max-w-[660px]">
      <div className="flex flex-col items-start px-16 py-16 text-white sm:px-48 sm:py-24 lg:px-[77px] lg:py-[59px]">
        {highlight && (
          <div className="mb-8 font-suisse-intl-mono text-overline-md text-primary-magenta">
            {highlight}
          </div>
        )}
        <h2 className="my-0 max-w-[505px] font-suisse-works text-headline-sm text-white sm:text-headline-lg">
          {title}
        </h2>
        {subtitle && (
          <p className="m-0 font-suisse-intl text-disclosure-lg sm:text-overline-lg">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default ModalHeaderSection;
